import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(() => ({
  sceneInfoText: {
    fontSize: '18px',
    lineHeight: '21px',
  },
  sceneInfo: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#141414',
    padding: '2% 0',
    marginBottom: 10,
    borderRadius: '5px',
    minHeight: 50,
  },
  iconButton: {
    padding: 5,
    marginRight: 15,
  },
  rightElementWrapper: {
    display: 'flex',
  },
  errorOutline: {
    marginRight: 3,
  },
  descriptionWrapper: {
    display: 'flex',
    alignItems: 'baseline',
  },
  colorBlock: {
    display: 'inline-block',
    width: 10,
    height: 10,
    border: '1px solid rgba(0,0,0, 0.3)',
    marginLeft: 3,
  },
}))

export default useStyles
